import { useState, useEffect } from 'react';

// Verificar se estamos em produção
const isProduction = window.location.protocol === 'https:';

// Configuração padrão (último fallback)
const defaultConfig = {
  baseURL: 'http://localhost:5000', // Fallback para desenvolvimento local
  endpoints: {
    search: '/api/search'
  },
  useCorsProxy: false,
  httpsReady: false
};

export function useApiConfig() {
  const [config, setConfig] = useState(defaultConfig);

  useEffect(() => {
    // Nova prioridade: config.json > VITE_API_URL > fallback
    // Isso permite alterações dinâmicas em produção
    
    // Carregar configuração do arquivo JSON primeiro (prioridade máxima)
    fetch('/config.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Falha ao carregar config.json');
        }
        return response.json();
      })
      .then(data => {
        console.log('Config carregada do config.json:', data);
        if (data && data.apiUrl) {
          let apiUrl = data.apiUrl;

          // Se o backend estiver pronto para HTTPS e estamos em HTTPS, forçamos HTTPS
          if (isProduction && data.httpsReady && apiUrl.startsWith('http:')) {
            apiUrl = apiUrl.replace('http:', 'https:');
            console.log('Convertendo URL para HTTPS:', apiUrl);
          }

          // Configuração carregada do arquivo config.json (PRIORIDADE MÁXIMA)
          const newConfig = {
            baseURL: apiUrl,
            endpoints: data.apiEndpoints || defaultConfig.endpoints,
            useCorsProxy: data.useCorsProxy !== undefined ? data.useCorsProxy : false,
            httpsReady: data.httpsReady !== undefined ? data.httpsReady : false
          };

          console.log('✅ Usando configuração do config.json (prioridade máxima):', newConfig);
          setConfig(newConfig);
          return; // Sair aqui para não usar VITE_API_URL
        }
        
        // Se config.json não tem apiUrl, tenta VITE_API_URL
        useEnvFallback();
      })
      .catch(error => {
        console.warn('Config.json não encontrado ou inválido, tentando VITE_API_URL:', error);
        // Se config.json falhar, usar VITE_API_URL como fallback
        useEnvFallback();
      });

    function useEnvFallback() {
      const envApiUrl = import.meta.env.VITE_API_URL;
      
      if (envApiUrl) {
        console.log('📝 Usando VITE_API_URL do .env como fallback:', envApiUrl);
        const envConfig = {
          baseURL: envApiUrl,
          endpoints: { search: '/api/search' },
          useCorsProxy: false,
          httpsReady: false
        };
        setConfig(envConfig);
      } else {
        console.log('⚠️ Usando configuração padrão hardcoded (último recurso)');
        // Configuração padrão já está definida no defaultConfig
      }
    }
  }, []);

  return config;
}
